import { gql } from "@apollo/client";

export const PARSE_GRID_FILES = gql`
  mutation ParseGridFiles($files: [Upload!]) {
    parseGridFiles(files: $files) {
      success
      error
      grids {
      	properties {
      	  key
      	  value
      	}
      	tiers {
      	  tier
      	  enrollments
      	  earnings
      	  retention
      	  second_usage
      	  valid_email
      	  invoice_submission
      	}
      }
    }
  }
`;

export const LOAD_NEW_GRIDS = gql`
  mutation LoadNewGrids($grids: [AmsGridInput!], $noCommit: Boolean!, $etc: String!) {
    loadNewGrids(grids: $grids, noCommit: $noCommit, etc: $etc) {
      success
      error
      grids {
      	properties {
      	  company
      	  enrollmentType
      	  tribalStatus
      	  masterOverride
      	  paygoOverride
      	  residualAmount
      	  letterName
      	  managerPassthrough
      	  stateGroup
      	  version
      	  notes
      	  name
      	}
      	tiers {
      	  tier
      	  enrollments
      	  earnings
      	  retention
      	  second_usage
      	  valid_email
      	  invoice_submission
      	}
      }
    }
  }
`;